import StudentsPage from "../AdminDashboard/StudentsPage";
import {
  fetchChannelPartnerStudentFilters,
  fetchChannelPartnerStudents,
  fetchChannelPartnerStudentStats,
} from "../../services/channelPartnerPortalApi";
import ChannelPartnerDashboardLayout from "./ChannelPartnerDashboardLayout";

const ChannelPartnerStudentsPage = () => (
  <StudentsPage
    fetchStudentStats={fetchChannelPartnerStudentStats}
    fetchStudentFilters={fetchChannelPartnerStudentFilters}
    fetchStudents={fetchChannelPartnerStudents}
    layoutComponent={ChannelPartnerDashboardLayout}
    pageTitle="Channel Student Record"
    listTitle="Channel Students List"
    totalLabel="Total Channel Students"
  />
);

export default ChannelPartnerStudentsPage;
